define(['assets/js/backbone-extended'], function(backboneExtended) {
    return backboneExtended.NestedModel.extend({
        defaults: {
            frontCoating: null,
            backCoating: null,
            filling: null,
            folding: null,
            scoring: null,
            hole_making: null,
            rc: null,
            substrate: null,
            thickness: null,
            trimming: null,
            uploadPattern: null
        }
    });
});
